(function (app) {

    var DeliveryServicePackageDetail = Backbone.Model.extend({

        defaults: {
            Amount: 0,
            DeliveryServicePackageDetailID: null,
            ExpiryDate: null,
            InitialCount: 0,
            Name: "",
            Purchased: false,
            RemainingCount: 0,
            OurpaySelectSelected: false
        },

        initialize: function () {
            _.bindAll(this, '_update');
            app.checkout.orderXhr.done(this._update);
            app.checkout.onUpdate(this._update);
        },

        _update: function (data) {
            if (data.DeliveryServicePackageDetail) {
                var option = _.findWhere(data.DeliveryOptions, { PostServiceId: 'OURPAYSELECT' });
                var isOurpaySelect = option && option.Selected || false;
                data.DeliveryServicePackageDetail.OurpaySelectSelected = isOurpaySelect;
                this.set(data.DeliveryServicePackageDetail);
            } else {
                this.clear();
            }
        }
    });

    app.models = _.extend({
        packageDetails: new DeliveryServicePackageDetail()
    }, app.models);

})(app);